import { Cartao, Titulo, TituloAcoes, Conteudo, Rotulo, ValorDestacado, Timestamp } from "../styles";
import { IconeSinalAlerta, IconClock } from "../../../icons/IconesSistema";
import { IconUser } from "../../../icons";
import { 
  RodapeCancelamento,
  RodapeContainer,
  AvatarContainer,
  InfoContainer,
  NomeContainer,
  NomeProfissional,
  CodigoProfissional
} from "./styles";
import { comum } from "../../../../styles/Themes/light";
import { useAuth } from "../../../../contexts/UserContext";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

const formatarDataRelativa = (data: string | Date | null | undefined): string => {
  if (!data) return "";
  try {
    const dataFormatada = new Date(data);
    if (Number.isNaN(dataFormatada.getTime())) return "";
    return formatDistanceToNow(dataFormatada, { 
      addSuffix: true, 
      locale: ptBR 
    });
  } catch (error) {
    return "";
  }
};

export default function CancelamentoDemanda({ demanda }: any) {
  const { user } = useAuth();
  const statusNormalizado = demanda?.status?.trim().toLowerCase();

  if (statusNormalizado !== "cancelada" && statusNormalizado !== "cancelado") {
    return null;
  }

  if (user?.profile === 'comum' || user?.profile === 'Solicitante') {
    return null;
  }

  const historicoCancelamento = (demanda as any)?.historico
    ?.filter((h: any) => h.acao?.toLowerCase().includes('Demanda cancelada') || h.acao?.toLowerCase().includes('cancelada'))
    ?.sort((a: any, b: any) => {
      const dataA = new Date(a.criado || 0).getTime();
      const dataB = new Date(b.criado || 0).getTime();
      return dataB - dataA;
    })?.[0];

  const mensagem = historicoCancelamento?.justificativa?.trim() 
    ? historicoCancelamento.justificativa 
    : (demanda?.justificativa_cancelamento?.trim() ? demanda.justificativa_cancelamento : "--");
  
  const nomeResponsavel = historicoCancelamento?.nome_responsavel || demanda?.nome_operador || demanda?.nomeOperador || "";
  const tipoResponsavel = historicoCancelamento?.tipo_responsavel || "";
  const idResponsavel = historicoCancelamento?.id_responsavel;
  const dataCancelamento = historicoCancelamento?.criado;
  const dataRelativa = formatarDataRelativa(dataCancelamento);
  
  const codigoFormatado = idResponsavel 
    ? (tipoResponsavel === 'Admin' ? `J${idResponsavel}` : tipoResponsavel === 'Operador' ? `P${idResponsavel}` : `D${idResponsavel}`)
    : "";
  const temIdentificacao = nomeResponsavel || codigoFormatado;

  return (
    <Cartao>
      <Titulo>
        <IconeSinalAlerta size={18} color="#ca8a04" />
        Cancelamento da Demanda
        {dataRelativa && (
          <TituloAcoes>
            <Timestamp>
              <IconClock size={14} />
              {dataRelativa}
            </Timestamp>
          </TituloAcoes>
        )}
      </Titulo>
      <Conteudo>
        {temIdentificacao && (
          <RodapeCancelamento>
            <RodapeContainer>
              <AvatarContainer>
                <IconUser color={comum.colors.primaryRed400} size={20} />
              </AvatarContainer>
              <InfoContainer>
                <NomeContainer>
                  {nomeResponsavel ? (
                    <>
                      <NomeProfissional>{nomeResponsavel.split(' ')[0]}</NomeProfissional>
                      {codigoFormatado && <CodigoProfissional>{codigoFormatado}</CodigoProfissional>}
                    </>
                  ) : codigoFormatado ? (
                    <NomeProfissional>{codigoFormatado}</NomeProfissional>
                  ) : null}
                </NomeContainer>
              </InfoContainer>
            </RodapeContainer>
          </RodapeCancelamento>
        )}

        <Rotulo>Mensagem do cancelamento</Rotulo>
        <ValorDestacado>{mensagem}</ValorDestacado>
      </Conteudo>
    </Cartao>
  );
}
